module.exports = __webpack_public_path__ + "img/dp-sy-lm3.8f92b24b.png";